'use client';

import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from '@/components/ui/tooltip';
import copy from 'copy-to-clipboard';
import { Link2Icon } from 'lucide-react';
import { QRCodeSVG } from 'qrcode.react';
import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { WeiboIcon, WeiXinIcon } from './icons';

interface SocialShareModalProps {
  url?: string;
  title?: string;
}

export default function SocialShareModal({
  url,
  title = '分享内容',
}: SocialShareModalProps) {
  const [currentUrl, setCurrentUrl] = useState(url || '');
  // 复制链接
  const handleCopyLink = () => {
    copy(currentUrl);
    toast.success('链接已复制到剪贴板', {
      position: 'top-center',
    });
  };

  // 分享到微信
  const handleWechatShare = async () => {
    try {
    } catch (error) {
      toast.error('微信分享失败，请稍后重试', {
        position: 'top-center',
      });
    }
  };

  // 分享到微博
  const handleWeiboShare = () => {
    const weiboUrl = encodeURIComponent(currentUrl);
    const weiboTitle = encodeURIComponent(title);
    const shareUrl = `https://service.weibo.com/share/share.php?url=${weiboUrl}&title=${weiboTitle}`;
    window.open(shareUrl, '_blank', 'width=600,height=400');
  };

  useEffect(() => {
    if (!url) {
      setCurrentUrl(window.location.href);
    }
  }, [url]);

  return (
    <div className="flex flex-col md:flex-row md:items-center gap-3 px-8 py-6">
      <p className="font-medium">分享</p>
      <Button
        className="bg-blue-500 hover:bg-blue-600 dark:bg-blue-400"
        onClick={handleCopyLink}
      >
        <Link2Icon className="w-8 h-8" />
        <div className="font-medium">复制链接</div>
      </Button>

      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            className="bg-green-500 hover:bg-green-600 dark:bg-green-400 hidden md:inline-flex"
            onClick={handleWechatShare}
          >
            <WeiXinIcon className="w-8 h-8" />
            <div className="font-medium">微信扫一扫</div>
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <div className="p-4 space-y-2">
            <QRCodeSVG value={currentUrl} />
            <p>使用微信扫一扫查看</p>
          </div>
        </TooltipContent>
      </Tooltip>
      <Button
        className="bg-red-500 hover:bg-red-600 dark:bg-red-400"
        onClick={handleWeiboShare}
      >
        <WeiboIcon className="w-8 h-8" />
        <div className="font-medium">分享到微博</div>
      </Button>
    </div>
  );
}
